import { CLOSE_QUOTE_BID_SEE_DETAIL_DIALOG, OPEN_QUOTE_BID_SEE_DETAIL_DIALOG } from './QuoteBidSeeDetailDialog.actions'

const quoteBidSeeDetailDialogState = {
  error: false,
  loading: false,
  open: false
}

/**
 * The Quote Bid See Detail Dialog' reducer.
 */
const QuoteBidSeeDetailDialogReducer = (state = quoteBidSeeDetailDialogState, { type }) => {
  switch (type) {
    case CLOSE_QUOTE_BID_SEE_DETAIL_DIALOG: {
      return { ...state, open: false }
    }
    case OPEN_QUOTE_BID_SEE_DETAIL_DIALOG: {
      return { ...state, open: true }
    }
    default: {
      return state
    }
  }
}

export default QuoteBidSeeDetailDialogReducer
